import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '@app/@core/@config/config.service';
import {convertJsonStringFieldToObject} from '@shared/utils/json-response-util';
import {Product} from '@app/@core/@models/design/product.model';
import {ResultList} from '@app/@core/@models/common/result-list';

export interface SiteGroupParams {
  context: string;
  orderBy: string;
  pageSize: number;
}

export interface SiteGroup {
  id: string;
  name: string;
}

export interface Site {
  id: string;
  name: string;
  siteUrl: string;
}

export interface SiteGroupAndSite {
  siteGroup: SiteGroup;
  sites: Array<Site>;
}

@Injectable({
  providedIn: 'root',
})
export class SiteGroupResource {
  constructor(private httpClient: HttpClient, private configService: ConfigService) {}

  getSiteGroupAndSites(params: SiteGroupParams): Observable<Array<SiteGroupAndSite>> {
    return this.httpClient
      .get<Array<SiteGroupAndSite>>(this.configService.getVersionedUri('sitegroups/selfservicerelated'), {
        params: new HttpParams()
          .set('context', params.context)
          .set('selfServiceProducts', true)
          .set('includeActive', true)
          .set('includeHidden', false)
          .set('includeInactive', false)
          .set('orderBy', params.orderBy)
          .set('pageSize', params.pageSize),
      });
  }

}
